const STORAGE_KEY = 'auction-reminders-enabled'

export const useAuctionReminders = () => {
  const enabled = ref(false)
  const permission = ref<NotificationPermission>('default')

  const load = () => {
    if (!import.meta.client) return
    const stored = localStorage.getItem(STORAGE_KEY)
    enabled.value = stored === 'true'
    permission.value = Notification.permission
  }

  const setEnabled = (value: boolean) => {
    if (!import.meta.client) return
    enabled.value = value
    localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false')
  }

  const requestPermission = async () => {
    if (!import.meta.client) return
    if (!('Notification' in window)) return
    const result = await Notification.requestPermission()
    permission.value = result
    if (result === 'granted') {
      setEnabled(true)
    }
  }

  return {
    enabled,
    permission,
    load,
    setEnabled,
    requestPermission,
  }
}

